import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//router
import { createBrowserRouter, RouterProvider } from "react-router-dom";
//store
import { Provider } from "react-redux";
//reducer
import { store } from "./store";

import Home from "./views/home";

import Index from "./views/index";
import SignIn from "./views/sign-in";
import SignUp from "./views/sign-up";
import Recoverpw from "./views/recoverpw";

import { IndexRouters } from "./router";
import { SimpleRouter } from "./router/simple-router";
import { DefaultRouter } from "./router/default-router";

import { AuthProvider } from './components/auth/AuthProvider';
import { LoaderProvider } from './components/loader/LoaderContext'; // Importa il contesto del Loader
import { LanguageProvider } from './i18n/LanguageContext';

const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthProvider><Home /></AuthProvider>,
  },
  {
    path: "/index",
    element: <Index />,
  },
  {
    path: "/sign-in",
    element: <AuthProvider><SignIn /></AuthProvider>,
  },
  {
    path: "/sign-up",
    element: <AuthProvider><SignUp /></AuthProvider>,
  },
  {
    path: "/recoverpw",
    element: <Recoverpw />,
  },
  ...DefaultRouter,
  ...IndexRouters,
  ...SimpleRouter
] ,{basename: process.env.PUBLIC_URL });

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <LanguageProvider>
        <LoaderProvider> {/* Avvolgi tutta l'app con il LoaderProvider */}
          <App>
            <RouterProvider router={router}></RouterProvider>
          </App>
        </LoaderProvider>
      </LanguageProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
